import React from 'react';
import styles from './index.module.scss';

interface IProps {
  childs?: JSX.Element[];
  heigth?: number;
  className?: string;
  style?: React.CSSProperties;
}

interface IState {
  childs?: JSX.Element[];
  heigth?: number;
  className?: string;
  style?: React.CSSProperties;

  parentContentWidth?: number;
  contentWidth?: number;
}

class Index extends React.Component<IProps, IState> {
  pos : number = 0;
  runauto : boolean = true;

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.auto();
  }
  
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState=> {
    let res : IState = { };
    if (p?.childs !== s?.childs) res.childs = p.childs;
    if (p?.heigth !== s?.heigth) res.heigth = p.heigth;
    if (p?.className !== s?.className) res.className = p.className;
    if (p?.style !== s?.style) res.style = p.style;
    return res;
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    new ResizeObserver((e) => (this.state.parentContentWidth !== e[0].contentRect.width) && this.setState({ parentContentWidth: e[0].contentRect.width }))
      .observe($("#carousel-content").parent()[0]);
    new ResizeObserver((e) => (this.state.contentWidth !== e[0].contentRect.width) && this.setState({ contentWidth: e[0].contentRect.width }))
      .observe($("#carousel-content")[0]);
  }

  move = (x:number) => {
    if (!this.state.parentContentWidth || !this.state.contentWidth) return;
    let tope = false;
    this.pos += x;
    let minLeft = ( this.state.parentContentWidth - this.state.contentWidth );
    if (x > 0 && this.pos > 0) { tope=true; this.pos = 0; }
    if (x < 0 && this.pos < minLeft) { tope=true; this.pos = minLeft; }
    $("#carousel-content").css("left", this.pos);
    return tope;
  }

  movestart = (action: boolean) => {
    this.runauto = action;
    if (action) this.auto();
  }

  auto = (interval: number = 100) => {
    setTimeout(() => {
      let tope = this.move(-3);
      if (tope) this.move(10000);  // full derecha
      
      if (this.runauto) this.auto(tope ? 1000 : 100);
    }, interval)
  }

  render() {
    const { childs, className, style } = this.state;

    console.log("SIZES: parent:", this.state.parentContentWidth, "carousel", this.state.contentWidth)
    return <>
      <div 
        className={className}
        style={{ ...{ display: 'flex', flexDirection: 'row' }, ...style }} 
        onMouseEnter={() => this.movestart(false)} 
        onMouseLeave={() => this.movestart(true)}
      >
        <div className={styles.button} onClick={() => this.move(50)}>&lsaquo;</div>
        <div style={{ width: '100%', height: this.state.heigth, overflow:'hidden', position: 'relative', display: 'flex', flexDirection: 'row' }}>
          <div id="carousel-content" style={{display: 'flex', height: this.state.heigth, alignItems: 'center', position: 'absolute', left: 0}}>
            {childs?.map(c => <div style={{ marginRight: 25 }}>{c}</div>)}
          </div>
        </div>
        <div className={styles.button} onClick={() => this.move(-50)}>&rsaquo;</div>
      </div>  
    </>;
  }
}

export default Index;
